export default __webpack_public_path__ + "static/media/GA_Mix-1.7c694f4b.wav";